import { useLocation } from 'react-router-dom';

export const useIsBuilderView = () => {
  const { pathname } = useLocation();
  return Boolean(pathname.includes('builder'));
};
